module.exports = __webpack_public_path__ + "img/22.8a7cf60b.png";